import {
  Form,
  Field,
  ModalContainer,
  ModalLayoutFullScreen,
} from '@kanda-libs/ks-component-ts';
import { Header, Button, Loader } from '@kanda-libs/ks-design-library';
import Container from './NameModal-container';
import {
  FIRST_NAME_VALIDATION,
  LAST_NAME_VALIDATION,
  WRAP_FIELDS,
} from './NameModal-constants';

import { NAME_MODAL_ID } from '../../Mobile-constants';

const ViewComponent = () => (
  <ModalContainer id={NAME_MODAL_ID}>
    {({ handleClose }) => (
      <Container handleClose={handleClose}>
        {({ form, onSubmit, isSubmitting, isLoading }) => (
          <Form
            id="account-settings-update-profile"
            form={form}
            onSubmit={onSubmit}
          >
            <ModalLayoutFullScreen
              noBorder
              footer={
                <Button.Text
                  id="account-settings-update-profile"
                  label="Update profile"
                  submit
                  variant="solid"
                  disabled={isSubmitting}
                  className="ml-auto"
                />
              }
              header={
                <Header.Base
                  className="text-style-f-em text-neutral-700"
                  options={[
                    <Button.Icon
                      id="account-settings-close-modal"
                      key="close"
                      onClick={handleClose}
                      icon="close"
                    />,
                  ]}
                />
              }
            >
              <div className="flex flex-col">
                <p className="mb-4 text-24-28-em">Change your name</p>
                <p className="mb-8 text-14-22">
                  Update your name assigned to your profile
                </p>
                <Field.Validator validation={FIRST_NAME_VALIDATION}>
                  <Field.Input
                    {...WRAP_FIELDS.firstName}
                    isLoading={isLoading}
                  />
                </Field.Validator>
                <Field.Validator validation={LAST_NAME_VALIDATION}>
                  <Field.Input
                    {...WRAP_FIELDS.lastName}
                    isLoading={isLoading}
                  />
                </Field.Validator>
              </div>
              <Loader isLoading={isSubmitting} />
            </ModalLayoutFullScreen>
          </Form>
        )}
      </Container>
    )}
  </ModalContainer>
);

ViewComponent.displayName = 'AccountSettings-Mobile-NameModal-view';

export default ViewComponent;
